import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import SiteHeader from "@/components/SiteHeader";

/**
 * Placeholder legal page. Replace the body with a lawyer-reviewed
 * agreement before publishing to paying customers. See /app/memory/LAUNCH.md.
 */

export default function LegalPage({
  title,
  intro,
  sections,
  testid = "legal-page",
}) {
  useEffect(() => {
    document.title = "SERP";
  }, [title]);

  return (
    <div className="min-h-screen bg-[#F5F7FA]" data-testid={testid}>
      <SiteHeader variant="public" />

      <main className="max-w-[860px] mx-auto px-6 py-16">
        <div className="mb-8">
          <div className="text-xs uppercase tracking-widest text-[#1C1C1C] font-semibold mb-3">Legal</div>
          <h1 className="font-heading font-black text-4xl md:text-5xl text-[#1A202C] tracking-tight mb-4">{title}</h1>
          <p className="text-[#4A5568]">Last updated: {new Date().toLocaleDateString("en-GB", { year: "numeric", month: "long", day: "numeric" })}</p>
        </div>

        <div className="flex items-start gap-2 p-3 mb-8 border border-[#F79009] bg-[#FFFAEB] text-xs text-[#B54708]">
          <strong>Draft</strong>&nbsp;— this is a placeholder template. Review with legal counsel before
          publishing to paying customers.
        </div>

        <div className="bg-white border border-[#DDE3ED] p-10 space-y-8">
          <p className="text-[#4A5568] leading-relaxed">{intro}</p>

          {sections.map((s, i) => (
            <section key={i}>
              <h2 className="font-heading font-bold text-xl text-[#1A202C] mb-3">{i + 1}. {s.heading}</h2>
              {s.paragraphs.map((p, j) => (
                <p key={j} className="text-[#4A5568] leading-relaxed mb-3">{p}</p>
              ))}
            </section>
          ))}

          <section>
            <h2 className="font-heading font-bold text-xl text-[#1A202C] mb-3">Questions?</h2>
            <p className="text-[#4A5568] leading-relaxed">
              Reach out any time via our <Link to="/contact" className="underline text-[#1C1C1C]">contact form</Link>. We aim to respond within one business day.
            </p>
          </section>
        </div>
      </main>

      <footer className="border-t border-[#DDE3ED] py-8 bg-white">
        <div className="max-w-[1400px] mx-auto px-6 flex flex-wrap items-center justify-between gap-4 text-xs text-[#4A5568]">
          <div>SERP · Shanvi Enterprise Resource Planning · a Shanvi Resources product</div>
          <div className="flex gap-4">
            <Link to="/terms" className="hover:text-[#1A202C]">Terms</Link>
            <Link to="/privacy" className="hover:text-[#1A202C]">Privacy</Link>
            <Link to="/contact" className="hover:text-[#1A202C]">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
